import { useAttribute } from "lib/hooks";
import { cloneElement, forwardRef, useMemo } from "react";

function Draggable({ children, path }, ref) {
  const [draggable] = useAttribute("draggable", false);
  const props = {
    ref,
    draggable,
    onDragStart: useMemo(() => {
      if (draggable) {
        return (e) =>
          e.dataTransfer.setData(
            "text/plain",
            JSON.stringify({ from: path, action: "MOVE" })
          );
      }
      return null;
    }, [draggable, path]),
  };
  return cloneElement(children, props);
}

export default forwardRef(Draggable);
